import { createContext, useContext } from 'react';

export interface Language {
  code: string;
  name: string;
}

export interface LanguageContextValue {
  currentLanguage: Language;
  supportedLanguages: Language[];
  changeLanguage: (code: string) => Promise<void>;
}

export const LanguageContext = createContext<LanguageContextValue | null>(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
